/**
 * Ao abrir o app numa viagem em que a pessoa deixou o compartilhamento
 * ligado, liga de novo — sem perguntar: ela já decidiu. Fica na casca, não na
 * tela do mapa, para o envio não parar quando ela troca de aba.
 */
import { useEffect } from 'react';

import { useAuthStore } from '../../auth/store';
import { lerViagemAtiva } from '../../trip/viagemAtiva';
import { useCompartilharPosicao } from './compartilhar';

export function useRetomarCompartilhamento(): void {
  const userId = useAuthStore((s) => s.user?.id ?? '');
  const retomar = useCompartilharPosicao((s) => s.retomar);
  const tripId = lerViagemAtiva(userId)?.id ?? '';
  useEffect(() => {
    if (tripId) retomar(tripId);
  }, [tripId, retomar]);
}
